import { createContext, useContext, useState, useCallback } from 'react'

const ModalContext = createContext()

export const ModalProvider = ({ children }) => {
  const [openOtp, setOpenOtp] = useState(false)
  const [resolveOtp, setResolveOtp] = useState(null)
  const [missingMethod, setMissingMethod] = useState(null)
  const [openValidEmail, setOpenValidEmail] = useState(false)
  const [resolveModal, setResolveModal] = useState(null)

  const showOtpModal = useCallback(() => {
    return new Promise(resolve => {
      setResolveOtp(() => resolve)
      setOpenOtp(true)
    })
  }, [])

  const hideOtpModal = useCallback(() => {
    setOpenOtp(false)
    if (resolveOtp) {
      resolveOtp(null)
      setResolveOtp(null)
    }
  }, [resolveOtp])

  const confirmOtpCode = useCallback(
    code => {
      if (resolveOtp) {
        resolveOtp(code)
      }
      setResolveOtp(null)
    },
    [resolveOtp]
  )
  const showValidEmail = () => {
    return new Promise(resolve => {
      setResolveModal(() => resolve)
      setOpenValidEmail(true)
    })
  }
  const confirmEmail = useCallback(
    email => {
      if (resolveModal) {
        resolveModal(email)
        setResolveModal(null)
      }
      setOpenValidEmail(false)
    },
    [resolveModal]
  )
  const hideValidEmail = () => {
    setOpenValidEmail(false)
    if (resolveModal) {
      resolveModal(null)
      setResolveModal(null)
    }
  }

  const showMethodNotRegistered = useCallback(method => {
    setMissingMethod(method)
  }, [])

  const hideMethodNotRegistered = useCallback(() => {
    setMissingMethod(null)
  }, [])

  return (
    <ModalContext.Provider
      value={{
        openOtp,
        confirmOtpCode,
        showOtpModal,
        hideOtpModal,
        missingMethod,
        showMethodNotRegistered,
        hideMethodNotRegistered,
        openValidEmail,
        showValidEmail,
        hideValidEmail,
        confirmEmail,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => useContext(ModalContext)
